import angular from 'angular';

/* eslint indent: "off" */
const userInGroupService = angular.module('ttb.services.configuration.userInGroup.service', [])
  .factory('userInGroupService', ['$q', '$http',
    ($q, $http) => {
      const url = '/api/configuration/user-in-group';

      const query = (filter) => {
        const { q, groupId, projects, teams } = filter || {};
        return $q((resolve, reject) => {
          $http.get(url, { params: { q, groupId, projects, teams } })
            .then((response) => {
              if (DEBUG) {
                console.log(response);
              }
              resolve(response.data);
            }, reject);
        });
      };

      const get = ({ userId, groupId }) => $q((resolve, reject) => {
        $http.get(`${url}/${groupId}/${userId}`)
          .then((response) => {
            if (DEBUG) {
              console.log(response);
            }
            resolve(response.data);
          }, reject);
      });

      const update = ({ userId, isActive, description, roleId, groupId }) => $q((resolve, reject) => {
        $http.post(url,
          {
            userId,
            isActive,
            description,
            roleId,
            groupId
          })
          .then((response) => {
            resolve(response.data);
          }, reject);
      });

      const getInviteUserTemplate = (groupId) => $q((resolve, reject) => {
          $http.get(`${url}/${groupId}/invite-template`)
              .then((response) => {
                  if (DEBUG) {
                      console.log(response);
                  }
                  resolve(response.data);
              }, reject);
      });

        const isUserExists = (groupId, email) => $q((resolve, reject) => {
            $http.get(`${url}/${groupId}/user-exists`, { params: { email } })
                .then((response) => {
                    if (DEBUG) {
                        console.log(response);
                    }
                    resolve(response.data);
                }, reject);
      });

        const inviteUser = (invite) => $q((resolve, reject) => {
            $http.post(`${url}/invite-user`, invite)
                .then((response) => {
                    if (DEBUG) {
                        console.log(response);
                    }
                    resolve(response.data);
                }, reject);
        });

        const removeUser = (userId, groupId) => $q((resolve, reject) => {
            $http.post(`${url}/${groupId}/remove-user`, userId)
                .then((response) => {
                    if (DEBUG) {
                        console.log(response);
                    }
                    resolve(response.data);
                }, reject);
        });

        const resendInvitation = (userId, groupId) => $q((resolve, reject) => {
            $http.post(`${url}/${groupId}/resend-invite`, userId)
                .then((response) => {
                    if (DEBUG) {
                        console.log(response);
                    }
                    resolve(response.data);
                }, reject);
        });

        return {
        query,
        get,
        update,
        getInviteUserTemplate,
        isUserExists,
        inviteUser,
        removeUser,
        resendInvitation
      };
    }])
  .name;

export default userInGroupService;



// WEBPACK FOOTER //
// ../services/configuration/user-in-group.service.js